<template>
  <sword-modal data-testid="modal_eligibilityError"
               class="modal__container"
               :header="$t('onboarding2_ohoh')"
               @close="closeModal"
  >
    <template slot="body">
      <p class="t2 -mb_3">
        {{ $t('onboarding_eligibility_failed1_body') }}
      </p>
      <ul class="t2 -mb_0 ul-bold">
        <li>{{ $t('onboarding_eligibility_failed1_list1') }}</li>
        <li v-if="availity">
          {{ $t('onboarding_eligibility_failed1_list2') }}
        </li>
        <li v-if="availity">
          {{ $t('onboarding_eligibility_failed1_list3') }}
        </li>
      </ul>
    </template>

    <template slot="footer">
      <sword-button-wuk data-testid="button_ok"
                        :text="$t('button.ok')"
                        @click.native="closeModal"
      />
    </template>
  </sword-modal>
</template>

<script>
// COMPONENTS
import { mapGetters } from 'vuex';
import SwordModal from '@ui-kit/components/modals/SwordModal.vue';
import SwordButtonWuk from '@ui-kit/components/buttons/SwordButton.vue';
import { applicationStoreTypes } from '@/store/types';

export default {
  name: 'EligibilityErrorModal',

  components: {
    SwordModal,
    SwordButtonWuk,
  },

  props: {
    availity: {
      type: Boolean,
      required: false,
    },
  },
  emits: ['close'],

  computed: {
    ...mapGetters({
      unit: applicationStoreTypes.getters.UNIT,
    }),
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal__container {
  &::v-deep {
    .sword-modal-body {
      margin-bottom: map-get($sh-spacers-wuk, 0) !important;
    }
  }
  p {
    text-align: left;
  }
}

.ul-bold {
    li {
      font-weight: bold;
      text-align: left;
      list-style: disc;
    }
}
</style>
